export default "__VITE_ASSET__CJ9ae33t__"